import { useArticleTitle } from '@article/shared/utils/use-article-title';
import { useArticleDescription } from '@article/shared/utils/use-article-description';
import { useArticleKeywords } from '@article/shared/utils/use-article-keywords';
import { CommonPageTDK } from '@lemon8/web-app-shared/ssr';
import { ArticleCanonical } from './canonical';

class PageTDK extends CommonPageTDK {
  CanonicalLink = () => <ArticleCanonical />;
}

export const ArticleTDK = () => {
  const tdkInfo = {
    title: useArticleTitle(),
    description: useArticleDescription(),
    keywords: useArticleKeywords(),
  };

  return <PageTDK {...tdkInfo} />;
};
